// ファイルに関する処理をまとめたファイル

/**
 * ファイル名から拡張子を取得する関数
 * @param filename ファイル名
 */
export const getExt = (filename) => {
  const pos = filename.lastIndexOf('.');
  if (pos === -1) return '';
  return filename.slice(pos + 1);
};
